// Measurement units grouped by category
export const UNIT_CATEGORIES = {
  Count: [
    "each (ea)",
    "piece (pc, pcs)",
    "dozen (doz)",
    "head (hd)",
    "bunch",
    "loaf",
  ],
  Packaging: [
    "pack (pk, pkg)",
    "packet",
    "bag",
    "bar",
    "bottle",
    "box",
    "can",
    "carton",
    "case",
    "container",
    "jar",
    "jug",
    "roll",
    "sleeve",
    "tub",
  ],
  Weight: [
    "ounce (oz)",
    "pound (lb)",
    "milligram (mg)",
    "gram (g)",
    "kilogram (kg)",
  ],
  Volume: [
    "teaspoon (tsp, t)",
    "tablespoon (tbsp, T)",
    "cup (c)",
    "fluid ounce (fl oz)",
    "gallon (gal)",
    "pint (pt)",
    "quart (qt)",
    "milliliter (ml)",
    "liter (L)",
  ],
} as const;

export const UNIT_CATEGORY_NAMES = Object.keys(
  UNIT_CATEGORIES,
) as (keyof typeof UNIT_CATEGORIES)[];

// Flat list for any consumers that just need all units
export const UNITS = UNIT_CATEGORY_NAMES.flatMap(
  (cat) => UNIT_CATEGORIES[cat] as readonly string[],
);

export type Unit =
  (typeof UNIT_CATEGORIES)[keyof typeof UNIT_CATEGORIES][number];
